function importAll(r) {
  return r.keys().map(r);
}

const Estonia_H = importAll(require.context('../assets/photos/Estonia_H', false, /\.(png|jpe?g|svg|pdf|mp4)$/));

export default Estonia_H;